import { StoreType } from 'utils/connect';
import { consumer } from '@tock/coretypes';
import { omit, pickBy } from 'es-toolkit/compat';
import { tocktix } from '@tock/protos/dist/types/clowncar';
import { useActions } from '@tock/shared/utils/connect';
import { useSelector } from 'react-redux';
import BusinessCollectionDataConfigurationForm, {
  BusinessCollectionDataConfigValues,
  emptyState,
} from 'routes/logged-in/data-configurations/BusinessCollectionDataConfigurationForm';

interface Props {
  editDataConfig?: consumer.ICollectionDataConfiguration;
  onCompleteOrCancel(): void;
}

const getInitialValues = (
  editCollectionConfig?: consumer.ICollectionDataConfiguration
): BusinessCollectionDataConfigValues => {
  if (!editCollectionConfig) {
    return emptyState;
  }
  const filteredConfig = pickBy(
    editCollectionConfig.collectionConfig,
    (value, __) => value !== null && value !== undefined
  );
  return {
    ...emptyState,
    name: editCollectionConfig.name || '',
    ...(filteredConfig as consumer.CollectionPageConfig),
    metroArea: filteredConfig.metroArea?.name || '',
  };
};

const EditBusinessCollectionDataConfigurationForm: React.FunctionComponent<
  React.PropsWithChildren<Props>
> = ({ editDataConfig, onCompleteOrCancel }) => {
  const { metroAreaList } = useSelector((state: StoreType) => ({
    metroAreaList: state.metroArea.metroAreaList,
  }));
  const { actions } = useActions();

  const onSubmit = async (values: BusinessCollectionDataConfigValues) => {
    const fullIMetroArea: tocktix.messages.IMetroArea | undefined = metroAreaList.find(
      ({ name }) => name === values.metroArea
    );

    const configuration: consumer.ICollectionDataConfiguration = {
      ...editDataConfig,
      collectionConfig: {
        ...editDataConfig?.collectionConfig,
        ...omit(values, 'name'),
        metroArea: fullIMetroArea,
        offeringSearchType: values.offeringSearchType,
      },
    };

    await actions.consumerPage.updateDataConfiguration(configuration);
    await actions.consumerPage.fetchAllCollectionDataConfigurations('ALL');

    onCompleteOrCancel();
  };

  const initialValues = getInitialValues(editDataConfig);

  const onClear = () => {
    onCompleteOrCancel();
  };

  return (
    <BusinessCollectionDataConfigurationForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      clearUpdatingConfig={onClear}
      updatingConfig={editDataConfig}
    />
  );
};

export default EditBusinessCollectionDataConfigurationForm;
